// extracted by mini-css-extract-plugin
export default {"player":"player_player__ZSQov","playerName":"player_playerName__kg1ei","count":"player_count__PyqHx","smallCount":"player_smallCount__zoAcT"};